interface NotificationBellIconProps {
  color?: string;
  dotColor?: string;
  className?: string;
  onClick?: () => void;
  size?: number;
}

function NotificationBellIcon({
  color,
  dotColor,
  className,
  onClick,
  size,
}: NotificationBellIconProps) {
  return (
    <svg
      width={size || 40}
      height={size || 40}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M36.1316 10.8477C34.526 10.2987 32.7989 10 31 10C22.4695 10 15.5542 16.7157 15.5542 25C15.554 27.1436 15.4261 29.1585 14.1389 31.0058C13.1561 32.399 11.8297 33.8258 11.5614 35.5392C11.1249 38.3274 13.0764 40.2625 15.4658 41.2268C24.6262 44.9244 37.3738 44.9244 46.5341 41.2268C48.9236 40.2625 50.875 38.3274 50.4386 35.5392C50.275 34.4942 49.7177 33.5558 49.0849 32.6667"
        stroke={color || 'var(--black)'}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="notification-dot"
        d="M50.5 21.5C50.5 17.3579 47.1421 14 43 14C38.8579 14 35.5 17.3579 35.5 21.5C35.5 25.6421 38.8579 29 43 29C47.1421 29 50.5 25.6421 50.5 21.5Z"
        stroke={dotColor || color || 'var(--black)'}
        fill={dotColor || 'none'}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
      />
      <path
        d="M24.5 49C26.0923 50.2438 28.195 51 30.5 51C32.805 51 34.9078 50.2438 36.5 49"
        stroke={color || 'var(--black)'}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NotificationBellIcon;
